"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBillingDetails = void 0;
const TaxId_1 = require("./TaxId");
const Address_1 = require("./Address");
const validation_1 = require("../validator/validation");
exports.isBillingDetails = (0, validation_1.isObjectOf)({
    taxId: (0, validation_1.optional)(TaxId_1.isTaxId),
    company: (0, validation_1.optional)(validation_1.isString),
    address: Address_1.isAddress,
});
//# sourceMappingURL=BillingDetails.js.map